import { render, staticRenderFns } from "./DialogPastaCompartilhamento.vue?vue&type=template&id=6a30f637"
import script from "./DialogPastaCompartilhamento.vue?vue&type=script&lang=js"
export * from "./DialogPastaCompartilhamento.vue?vue&type=script&lang=js"
import style0 from "./DialogPastaCompartilhamento.vue?vue&type=style&index=0&id=6a30f637&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports